import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useRefCallback } from '@tencent/glue-react-use';
import React, { useEffect, useRef, useState } from 'react';
import { usePrefixCls } from '../../../../config/hooks/usePrefixCls';
import { Modal } from '../../../Modal';
export var Uploading = function Uploading(props) {
  var show = props.show,
    onClose = props.onClose,
    avatarStyle = props.avatarStyle,
    previewUrl = props.previewUrl,
    _props$desc = props.desc,
    desc = _props$desc === void 0 ? '图片上传中，请稍后...' : _props$desc,
    _props$progressColor = props.progressColor,
    progressColor = _props$progressColor === void 0 ? '#296BEF' : _props$progressColor;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    percent = _useState2[0],
    setPercent = _useState2[1];
  var timerRef = useRef(0);
  var stopProgress = useRefCallback(function () {
    clearTimeout(timerRef.current);
    setPercent(0);
  });
  var closeHandle = useRefCallback(function () {
    stopProgress();
    onClose === null || onClose === void 0 ? void 0 : onClose();
  });
  var startProgress = useRefCallback(function () {
    if (percent >= 90) {
      return;
    }
    setPercent(percent + 5);
    timerRef.current = window.setTimeout(startProgress, 1000);
  });
  useEffect(function () {
    show ? startProgress() : stopProgress();
    return function () {
      clearTimeout(timerRef.current);
    };
  }, [show]);
  var cls = usePrefixCls('material-library-uploading');
  var progressStyle = {
    backgroundColor: progressColor,
    boxShadow: "0 0 0 4px ".concat(progressColor),
    border: "solid 1px ".concat(progressColor)
  };
  return React.createElement(Modal, {
    title: "",
    show: show,
    bodyStyle: {
      width: 400
    },
    footer: null,
    onCancel: closeHandle,
    maskClosable: false
  }, React.createElement("article", {
    className: cls
  }, React.createElement("span", {
    className: "".concat(cls, "-avatar"),
    style: _objectSpread({
      backgroundImage: "url(".concat(previewUrl, ")")
    }, avatarStyle)
  }, React.createElement("span", {
    className: "".concat(cls, "-progress")
  }, React.createElement("i", {
    className: "".concat(cls, "-progress-inner"),
    style: _objectSpread({
      width: "".concat(percent, "%")
    }, progressStyle)
  }))), React.createElement("p", {
    className: "".concat(cls, "-msg")
  }, desc)));
};